<template>
  <div id="app">
    <div v-if="isLoginPage">
      <router-view />
    </div>
    <div v-else class="d-flex min-vh-100">
      <Sidebar />
      <div class="main-content flex-grow-1">
        <div class="p-4">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import { useAuthStore } from '@/stores/auth'
export default {
  name: "App",
  components: {
    Sidebar
  },
  methods: {
    async logout() {
      const auth = useAuthStore()
      await auth.logout()
      this.$router.push('/login')
    },
  },
  computed: {
isLoginPage() {
  const p = this.$route.path
  return (
    p === '/login' ||
    p === '/forgot-password' ||
    p === '/reset-password' ||
    p.startsWith('/shop') ||
    p.startsWith('/cart') ||
    p.startsWith('/favorites')
  )
},
    isAuthenticated() {
      return useAuthStore().isAuthenticated
    }
  }
}
</script>

<style>
#app {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  -moz-osx-font-smoothing: grayscale;
  color: #141824;
  background-color: #f5f7fa;
}

body {
  margin: 0;
}

.bg-warning {
  color: black;
}

.form-control:focus,
.page-link:focus,
.form-select:focus,
.form-check-input:focus {
  box-shadow: 0 0 0 .05rem rgba(13, 110, 253, .25);
}


/* Bazowe zmienne (kolory możesz dostroić pod swój brand) */
:root {
  --phoenix-primary-bg-subtle: #E1EFFE;
  --phoenix-primary-text: #0F6CBD;

  --phoenix-success-bg-subtle: #D9FBD0;
  --phoenix-success-text: #3A7D44;

  --phoenix-info-bg-subtle: #CCF4FE;
  --phoenix-info-text: #087990;

  --phoenix-warning-bg-subtle: #FFF4D5;
  --phoenix-warning-text: #B54708;

  --phoenix-danger-bg-subtle: #FFE0E0;
  --phoenix-danger-text: #B42318;

  --phoenix-secondary-bg-subtle: #F2F4F7;
  --phoenix-secondary-text: #344054;

  --phoenix-font-size: 12px;
  --phoenix-font-weight: 600;
  --phoenix-radius: 0.25rem;
}

.badge-phoenix {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  font-size: var(--phoenix-font-size);
  font-weight: var(--phoenix-font-weight);
  border-radius: var(--phoenix-radius);
  border-color: var();
  line-height: 1;
  white-space: nowrap;
}

/* Warianty */
.badge-phoenix-primary {
  background: var(--phoenix-primary-bg-subtle);
  color: var(--phoenix-primary-text);
}

.badge-phoenix-success {
  background: var(--phoenix-success-bg-subtle);
  color: var(--phoenix-success-text);
}

.badge-phoenix-info {
  background: var(--phoenix-info-bg-subtle);
  color: var(--phoenix-info-text);
}

.badge-phoenix-warning {
  background: var(--phoenix-warning-bg-subtle);
  color: var(--phoenix-warning-text);
}

.badge-phoenix-danger {
  background: var(--phoenix-danger-bg-subtle);
  color: var(--phoenix-danger-text);
}

.badge-phoenix-secondary {
  background: var(--phoenix-secondary-bg-subtle);
  color: var(--phoenix-secondary-text);
}

/* Outline warianty */
.badge-outline {
  font-weight: 600;
  border: 1px solid;
}

.badge-outline.badge-phoenix-primary {
  color: var(--phoenix-primary-text);
  border-color: var(--phoenix-primary-text);
}

.badge-outline.badge-phoenix-success {
  color: var(--phoenix-success-text);
  border-color: var(--phoenix-success-text);
}

.badge-outline.badge-phoenix-info {
  color: var(--phoenix-info-text);
  border-color: var(--phoenix-info-text);
}

.badge-outline.badge-phoenix-warning {
  color: var(--phoenix-warning-text);
  border-color: var(--phoenix-warning-text);
}

.badge-outline.badge-phoenix-danger {
  color: var(--phoenix-danger-text);
  border-color: var(--phoenix-danger-text);
}

.badge-outline.badge-phoenix-secondary {
  color: var(--phoenix-secondary-text);
  border-color: var(--phoenix-secondary-text);
}
</style>
